import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

export const Container = styled.div`
  width: 85vw;
  padding: 0 0 24px 0;
  ${handleQuery(css``)}
`;

export const ContentChat = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 8px;
  border-radius: 8px 8px 0 0;
  background-color: ${({ color }) => color};
`;

export const ContainerIframe = styled.div`
  iframe {
    height: 65vh;
  }
`;
